import SignUpForm from 'src/javascripts/components/forms/SignUpForm';

export default class UsersEdit {

  constructor() {}

  render() {

    // Sign up form and password visibility
    SignUpForm();

    // Enable delete account button on type of 'CONFIRM'
    $('#confirm_deletion').on('input', function() {
      let val = $(this).val();
      if (val === 'CONFIRM') {
        $('.delete-account-button').removeClass('disabled');
      } else {
        $('.delete-account-button').addClass('disabled');
      }
    });

  }

}